import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface UsersData {
  name: string;
  id: number;
}

@Component({
  selector: 'app-details-appointment',
  templateUrl: './details-appointment.component.html',
  styleUrls: ['./details-appointment.component.css']
})
export class DetailsAppointmentComponent {

  action: string;
  appointment: any;

  constructor(
    public dialogRef: MatDialogRef<DetailsAppointmentComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {

    this.appointment = { ...data };
    this.appointment.stampTickets = [];
    this.appointment.sectionalItemRequestList.forEach(sectionalItemRequest => {
      if (sectionalItemRequest.stampTicket) {
        this.appointment.stampTickets.push(sectionalItemRequest.stampTicket);
      }
    });
    this.appointment.applicant.gender = this.appointment.applicant.sex === 'M' ? 'Masculino' : 'Femenino';
    this.appointment.applicant.formatedBirthDate = new Date(this.appointment.applicant.birthDate).toLocaleDateString();
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
